import React from 'react'
import ReadMoreButton from '../../read-more-button'
import { DocLink } from './doc-link'
import { useDocLink } from '../../../hooks/useDocLink'
import type { Blog } from '@ztechapps/common.contract'
import { formatDate } from '@ztechapps/common.utils'
export const DocPreview = ({ post }: { post: Blog }) => {
  const { url } = useDocLink(post)

  return (
    <article className="entry">
      <div className="entry-img">
        <img src={post?.cover} alt="feature" className="img-fluid" />
      </div>
      <h2 className="entry-title">
        <DocLink slug={post.slug}>{post?.title}</DocLink>
      </h2>
      <div className="entry-meta">
        <ul>
          <li className="d-flex align-items-center">
            <i className="bi bi-clock" />{' '}
            <DocLink slug={post.slug}>
              <time dateTime={post?.updatedAt?.toISOString?.()}>{formatDate(post?.updatedAt)}</time>
            </DocLink>
          </li>
        </ul>
      </div>
      <div className="entry-content">
        <p>{post?.description}</p>
        <ReadMoreButton url={url} />
      </div>
    </article>
  )
}
